import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import * as ACTIONS from "../../../store/actions"
import * as clearview from "../../../components/@Clearview"

import { Container, Row, Col } from "../../../components"

import { HeaderMain } from "../../components/HeaderMain"
import { Spinner } from "../../components/Spinner"

import { QueriesTable } from "./components/QueriesTable"

class QueriesDashboardComponent extends Component {
	static propTypes = {
		queries: PropTypes.array.isRequired,
		filter: PropTypes.object,
		isBusy: PropTypes.bool.isRequired,
		lastUpdated: PropTypes.number,
	}

	componentDidMount() {
		// this.props.doRefresh()
	}

	render() {
		const { queries } = this.props
		return (
			<React.Fragment>
				<Container className={this.props.isBusy ? "isBusy" : ""}>
					{this.props.isBusy && <Spinner key="spinner"></Spinner>}
					<HeaderMain
						title={<span className="text-primary">{clearview.Icon.query}Queries</span>}
						className="mb-4 mt-0"
						onRefresh={() => this.props.doRefresh()}
					/>
					<Row>
						<Col lg={12}>
							<QueriesTable queries={queries} filter={this.props.filter} />
						</Col>
					</Row>
				</Container>
			</React.Fragment>
		)
	}
}

function QueriesDashboard({ queries, filter, isBusy, lastUpdated, preFilterContext, doRefresh }) {
	preFilterContext.checkIfPreFilterLinked()
	return <QueriesDashboardComponent queries={queries} filter={filter} isBusy={isBusy} lastUpdated={lastUpdated} doRefresh={doRefresh} />
}

const mapStateToProps = state => {
	var subState = ACTIONS.getSubState(state, "clientsReducer\\periodEnds")
	var queries = ACTIONS.dictionaryToArray(subState.dict).flatMap(pe =>
		pe.stages.flatMap(s => s.comments?.filter(it => ["DraftQuery", "Query", "ClosedQuery"].includes(it.type)))
	)

	return {
		...subState,
		queries: queries,
		filter: clearview.QueryObject(window.location.search),
	}
}

const mapDispatchToProps = dispatch => ({
	doRefresh: () => {
		dispatch({ type: ACTIONS.USER_AUTHENTICATED, payload: {} })
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(QueriesDashboard)
